import React from 'react';
import {useSelector} from 'react-redux';
import NobulaLogo from '../../../../../../assets/icons/NobulaLogo.svg';
import Button from '../../../../../incase-domain/components/button/Button';
import {selectedPresentationSelector} from '../../../../../store/selectors/presentation.selectors';

function MobileViewHeader(): JSX.Element {
    const selectedPresentation = useSelector(selectedPresentationSelector);

    return (
        <div className="p-presEdit__mobileHeader">
            <div className="p-presEdit__mobileHeader_content">
                <div className="p-presEdit__mobileHeader_logo">
                    <img src={NobulaLogo} alt="Nobula Logo" />
                </div>
                <div className="p-presEdit__mobileHeader_title">{selectedPresentation.name}</div>
                <div className="p-presEdit__mobileHeader_menu">
                    <Button leading="ph:list" dynamicSize square variant="ghost" />
                </div>
            </div>
        </div>
    );
}

export default MobileViewHeader;
